import React from 'react';
import { BringzzIcon } from '@bringzz/components';

const getManeuverIcon = (maneuverType) => {
    // Map Apple MapKit maneuver types to icons
    // Based on actual navigation data from Apple MapKit
    const iconMap = {
        '1': <BringzzIcon icon="IconArrowLeft" folder="LineIcons" size="24" className="text-white" />, // Turn left
        '2': <BringzzIcon icon="IconArrowRight" folder="LineIcons" size="24" className="text-white" />, // Turn right
        '3': <BringzzIcon icon="IconArrowUp" folder="LineIcons" size="24" className="text-white" />, // Continue straight
        '4': <BringzzIcon icon="IconArrowUpRight" folder="LineIcons" size="24" className="text-white" />, // Slight right
        '5': <BringzzIcon icon="IconArrowUpLeft" folder="LineIcons" size="24" className="text-white" />, // Slight left
        '6': <BringzzIcon icon="IconCornerUpRight" folder="LineIcons" size="24" className="text-white" />, // Sharp right
        '7': <BringzzIcon icon="IconCornerUpLeft" folder="LineIcons" size="24" className="text-white" />, // Sharp left
        '8': <BringzzIcon icon="IconArrowUp" folder="LineIcons" size="24" className="text-white" />, // Merge
        '9': <BringzzIcon icon="IconLogOut" folder="LineIcons" size="24" className="text-white" />, // Exit
        '10': <BringzzIcon icon="IconArrowUpRight" folder="LineIcons" size="24" className="text-white" />, // Ramp right
        '11': <BringzzIcon icon="IconArrowUpLeft" folder="LineIcons" size="24" className="text-white" />, // Ramp left
        '12': <BringzzIcon icon="IconArrowUp" folder="LineIcons" size="24" className="text-white" />, // Continue
        '34': <BringzzIcon icon="IconMapPin" folder="LineIcons" size="24" className="text-white" />, // Destination/Arrive
    };

    return iconMap[maneuverType] || <BringzzIcon icon="IconArrowUp" folder="LineIcons" size="24" className="text-white" />;
};

const NavigationOverlay = ({ nextManeuver, distance, instruction }) => {
    // Format distance display
    const formatDistance = (dist) => {
        if (!dist) return 'Calculating...';
        
        if (dist < 1000) {
            return `In ${Math.round(dist)} m`;
        } else {
            return `In ${(dist / 1000).toFixed(1)} km`;
        }
    };

    return (
        <div 
            className="absolute top-20 left-1/2 transform -translate-x-1/2 bg-magic-lilac text-white p-4 rounded-lg shadow-lg z-50 min-w-[300px]"
            style={{ border: '2px solid white' }}
        >
            <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full">
                    {getManeuverIcon(nextManeuver)}
                </div>
                <div>
                    <div className="text-lg font-semibold">
                        {instruction || 'Continue on route'}
                    </div>
                    <div className="text-sm opacity-80">
                        {formatDistance(distance)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NavigationOverlay; 